// src/components/common/ErrorBoundary.tsx
// ============================================================
// SALT — Error Boundary
// Without one, any uncaught render error unmounts the whole React
// tree and the user sees a blank screen (navbar included). Wrapped
// around page content in PageLayout so the navbar keeps working and
// the user gets a message and a way back.
// ============================================================

import React from 'react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error('[ErrorBoundary] render error:', error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="sl-error-boundary">
        <h2 className="sl-error-boundary-title">Something went wrong</h2>
        <p className="sl-error-boundary-text">
          This page hit an unexpected error. Try reloading, or head back to the dashboard.
        </p>
        <div className="sl-error-boundary-actions">
          <button type="button" className="sl-error-boundary-btn" onClick={() => window.location.reload()}>
            Reload page
          </button>
          <a className="sl-error-boundary-btn" href="/">
            Go to dashboard
          </a>
        </div>
      </div>
    );
  }
}
